import { render, staticRenderFns } from "./GrowShrink.vue?vue&type=template&id=0931a31e"
import script from "./GrowShrink.vue?vue&type=script&lang=js"
export * from "./GrowShrink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports